import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, pipe } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Stream } from '../models/stream';
import { iHttpPaginatedResponse } from '../interfaces/iHttpPaginatedResponse';
import { StreamCourse } from '../models/streamCourse';

@Injectable({
  providedIn: 'root'
})

export class StreamService {
    constructor(private http: HttpClient) {
    }

    public getStreams(page,pp,sorts,filters): Observable<iHttpPaginatedResponse> {
        return this.http.get<iHttpPaginatedResponse>(environment.apiEndpoint + `/api/admin/stream?page=${page}&pp=${pp}&sort=${sorts}&${filters}`).pipe(
            map(res => {
                let streams=[];
                res.data.forEach(stream=>{
                    streams.push(new Stream(stream));
                });
                res.data = streams;
                return res;
            })
        );
    }

    public getStreamsFlat(): Observable<any>{
      return this.http.get(environment.apiEndpoint+'/api/admin/streams').pipe(
        map(
          res=>{
            return res;
          }
        )
      );
    }

    public updateFeaturedSeries(updates:any): Observable<any>{
      return this.http.put(environment.apiEndpoint+'/api/admin/streams/featured', {updates:updates}).pipe(
        map(
          res=>{
            return res;
          }
        )
      );
    }

    public getStream(id,includes): Observable<Stream> {
        return this.http.get<Stream>(environment.apiEndpoint + `/api/admin/stream/${id}?${includes}`).pipe(
            map(res => {
                return new Stream(res);
            })
        );
    }

    public deleteStream(id): Observable<any> {
        return this.http.delete<any>(environment.apiEndpoint + `/api/admin/stream/${id}`).pipe(
            map(res => {
                return res;
            })
        );
    }

    public addStream(stream: Stream): Observable<any> {
      return this.http.post<Stream>(environment.apiEndpoint + '/api/admin/stream', stream).pipe(
        map(res => {
          return new Stream(res);
        })
      );
    }

    public updateStream(stream: Stream): Observable<any> {
        return this.http.put<any>(environment.apiEndpoint + `/api/admin/stream/${stream.id}`,{stream: stream}).pipe(
            map(res => {
                return new Stream(res);
            })
        );
    }

    public addCourse(streamCourse:StreamCourse): Observable<StreamCourse>{
        return this.http.post<StreamCourse>(environment.apiEndpoint + `/api/admin/stream/course`,streamCourse).pipe(
            map(res => {
                return new StreamCourse(res);
            })
        );
    }

    public deleteCourse(streamCourse:StreamCourse): Observable<StreamCourse>{
        const options = {
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
            }),
            body: streamCourse,
        };
        return this.http.delete<StreamCourse>(environment.apiEndpoint + `/api/admin/stream/course`,options).pipe(
            map(res => {
                return res;
            })
        );
    }

    public getGlobalDiscounts():Observable<any>{
      return this.http.get(environment.apiEndpoint+'/api/admin/streamGlobalDiscounts').pipe(
        map(
          res=>{
            return res;
          }
        )
      );
    }

    public addDiscount(streamId:number, discount:any):Observable<any>{
      return this.http.post(environment.apiEndpoint+'/api/admin/stream/discount', {streamId:streamId, discount:discount}).pipe(
        map(
          res=>{
            return res;
          }
        )
      );
    }

    public addGlobalDiscount(discount:any):Observable<any>{
      return this.http.post(environment.apiEndpoint+'/api/admin/stream/globalDiscount', {discount:discount}).pipe(
        map(
          res=>{
            return res;
          }
        )
      );
    }

    public deleteDiscount(discountId:number, streamId:number):Observable<any>{
      return this.http.delete(environment.apiEndpoint+`/api/admin/stream/discount/${streamId}/${discountId}`).pipe(map(
        res=>{
          return res;
        }
      ));
    }

    public deleteGlobalDiscount(discountId:number):Observable<any>{
      return this.http.delete(environment.apiEndpoint+`/api/admin/streamGlobalDiscount/${discountId}`).pipe(map(
        res=>{
          return res;
        }
      ));
    }
}
